import { render, staticRenderFns } from "./educationSelect.vue?vue&type=template&id=1cb8c7fd&"
import script from "./educationSelect.vue?vue&type=script&lang=js&"
export * from "./educationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports